var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearchinline = function SvgSearchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_1432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.779 22.72-6.633-6.633c1.462-1.707 2.31-3.914 2.31-6.338A9.749 9.749 0 0 0 9.708 0C4.323 0 0 4.365 0 9.75c0 5.384 4.365 9.749 9.707 9.749a9.698 9.698 0 0 0 6.337-2.35l6.633 6.632c.188.143.38.218.572.218a.746.746 0 0 0 .53-.22.745.745 0 0 0 0-1.06ZM9.749 18A8.235 8.235 0 0 1 1.5 9.75c0-4.547 3.662-8.25 8.25-8.25C14.34 1.5 18 5.16 18 9.75A8.235 8.235 0 0 1 9.75 18Z",
    fill: "#250002"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_1432"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgSearchinline;